export const VIEWPORT_MARGIN = 8
export const CHART_LINE_LABEL_ID = 'chart-line-label'
export const LABEL_HEIGHT_INCREASE = 36
